module.exports = __webpack_public_path__ + "static/img/badge-multi-scheduled-mandatory-irregular.d13edbe.svg";